import { isBefore } from "date-fns";
import { isDefined } from "@clipboard-health/util-ts";

/**
 * Workplaces created on or after this date do not see the classic calendar.
 * Remove this constant (and all references) once the classic calendar feature
 * is fully deprecated.
 */
const CLASSIC_CALENDAR_CUTOFF_DATE = new Date("2026-05-27T00:00:00.000Z");

export function isWorkplaceCreatedBeforeClassicCalendarCutoff(
  workplaceCreatedAt: string | undefined
): boolean {
  if (!isDefined(workplaceCreatedAt)) {
    return false;
  }

  return isBefore(new Date(workplaceCreatedAt), CLASSIC_CALENDAR_CUTOFF_DATE);
}
